<template>
  <div class="IssueFoundDiv">
    <div class="IssueFound">
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">基础信息</div>
      </div>
      <div class="userData">
        <el-form :model="userData" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="userData.name" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="userData.phone" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">寻人描述</div>
      </div>
      <div class="describe">
        <el-form :model="describe" :rules="describeRules" ref="describeForm" class="demo-ruleForm">
          <el-form-item prop="title">
            <el-input v-model="describe.title" placeholder="请输入寻人主题"></el-input>
          </el-form-item>
          <el-form-item prop="type">
            <el-select v-model="describe.type" placeholder="寻人类型">
              <el-option label="寻人" value="0"></el-option>
              <el-option label="招聘" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="content">
            <el-input type="textarea" placeholder="请描述您要寻找的人" v-model="describe.content" maxlength="200" show-word-limit
              :autosize="{ minRows: 6, maxRows: 6 }">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="submit">
        <button class="submitBtn" @click="submit">提 交</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userData: {
        name: "",
        phone: "1",
        email: "1",
      },
      describe: {
        title: "",
        type: "",
        content: "",
      },
      describeRules: {
        title: [
          { required: true, message: "请输入寻人主题", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择寻人类型", trigger: "change" },
        ],
        content: [
          { required: true, message: "请描述您要寻找的人", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    async getUserData() {
      const result = await this.$http.get("/otherApplyinfos/getBasicInfo", {
        params: { openid: window.localStorage.getItem("openid") }
      });
      this.userData.name = result.data.name;
      if (result.data.phone !== "") {
        this.userData.phone = result.data.phone;
      } else if (
        result.data.phone == "" &&
        result.data.email !== null
      ) {
        this.userData.email = result.data.email;
      }
    },
    submit() {
      this.$refs.describeForm.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: "/peopleSearch/pushPeopleSearch",
          method: "POST",
          data: {
            userId: parseInt(window.localStorage.getItem("user_id")),
            type: this.describe.type,
            title: this.describe.title,
            content: this.describe.content,
          },
        });
        if (result.data.success == true) {
          this.$toast("提交成功");
          window.history.back(-1);
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.IssueFoundDiv {
  position: relative;

  .IssueFound {
    position: relative;
    left: 5%;
    width: 90%;
    min-height: 90vh;
  }

  .userData {
    margin-top: 10px;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 15px;

    .el-form-item {
      position: relative;
      left: 3%;
      width: 94%;
      margin-top: 15px;
    }
  }

  .describe {
    margin-top: 10px;

    .el-form-item {
      margin-top: 15px;
    }
  }

  .submit {
    position: absolute;
    bottom: 0%;
    width: 100%;

    .submitBtn {
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}

.title {
  margin-top: 10px;

  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }

  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}

.el-select {
  width: 100%;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/service/IssueFound.vue